import React from "react";
import { Link } from "react-router-dom";
import { PublicHeader, SeoHead } from "@/components/PublicSeo";
import { SeoFooter } from "@/components/SeoFooter";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background" data-testid="not-found-page">
      <SeoHead title="Page not found | InfluencerCollab" robots="noindex,follow" />
      <PublicHeader />
      <main className="max-w-3xl mx-auto px-5 py-24 text-center">
        <p className="text-sm font-bold uppercase tracking-widest text-brand-pink mb-3">404</p>
        <h1 className="font-heading font-black text-4xl sm:text-5xl mb-4">This page doesn't exist</h1>
        <p className="text-muted-foreground mb-8">The link may be wrong or the page was removed.</p>
        <Link to="/influencer-directory" data-testid="not-found-directory-link" className="rounded-full bg-brand-pink text-white px-6 py-3 font-semibold">Browse influencer pages</Link>
      </main>
      <SeoFooter />
    </div>
  );
}
